export const REQUEST_TOKEN_PENDING = 'REQUEST_TOKEN_PENDING'
export const REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS'
export const REQUEST_TOKEN_FAILED = 'REQUEST_TOKEN_FAILED'
export const CHECK_TOKEN_VALID = 'CHECK_TOKEN_VALID'